const getIndexOfNextNonRevisionPhase = (phaseIndex: number, phases: any) => {
  let index = phaseIndex + 1;
  while (index < phases.length && phases[index].isRevision) {
    index++;
  }
  if(phases[index] && !phases[index].isRevision)
  {return index;}

  return -1;
};

export default getIndexOfNextNonRevisionPhase;
